import { ValidationProvider, ValidationObserver } from "vee-validate";
import "./validation/CustomRules";

import CollapseTransition from "./transitions/CollapseTransition.vue";
import DashboardTabsOffset from "./layouts/DashboardTabsOffset.vue";
import Button from "./buttons/Button.vue";
import CardStackedList from "./card/content/CardStackedList.vue";
import Icon from "./icon/Icon.vue";
import IconButton from "./buttons/IconButton.vue";
import DropdownButtonList from "./buttons/DropdownButtonList.vue";
import Card from "./card/Card.vue";
import Collapse from "./collapse/Collapse.vue";
import FormGrid from "./grids/FormGrid.vue";
import FormGridItem from "./grids/FormGridItem.vue";
import FormStep from "./form/FormStep.vue";
import InputWrapper from "./input/InputWrapperComponent.vue";
import FormInput from "./input/Input.vue";
import FormTextarea from "./input/Textarea.vue";
import FormIndicator from "./form/FormIndicator.vue";
import MainForm from "./form/MainForm.vue";
import HeaderCard from "./card/HeaderCard.vue";
import RoundedButton from "./buttons/RoundedButton.vue";
import CardLargeText from "./card/content/CardLargeText.vue";
import CardList from "./card/content/CardList.vue";
import GeneralContainer from "./containers/GeneralContainer.vue";
import MasonryGrid from "./grids/MasonryGrid.vue";
import MasonryGridItem from "./grids/MasonryGridItem.vue";
import GeneralGrid from "./grids/Grid.vue";
import GeneralGridItem from "./grids/GridItem.vue";
import MainTable from "./tables/MainTable.vue";
import ThinButtonWrapper from "./buttons/ThinButtonWrapper.vue";
import CustomerPage from "./layouts/customer_page/CustomerPage.vue";
import PageHeader from "./layouts/PageHeader.vue";
import CustomTable from "./tables/CustomTable.vue";
import SubTabGroup from "./tabs/SubTabGroup.vue";
import SubTabContentWrapper from "./tabs/SubTabContentWrapper.vue";
import SubTabContent from "./tabs/SubTabContent.vue";
import SubTabs from "./tabs/SubTab.vue";
import Tab from "./tabs/Tab.vue";
import TabPane from "./tabs/TabPane.vue";
import Avatar from "./customers/Avatar.vue";
import AvatarAndName from "./customers/AvatarAndName.vue";
import FormSelect from "./input/Select.vue";
import FormDatePicker from "./input/DatePicker.vue";
import TaskButton from "./buttons/TaskButton.vue";
import Radio from "./input/Radio.vue";
import Checkbox from "./input/Checkbox.vue";
import Pagination from "./pagination/Pagination.vue";
import RadioGroup from "./input/RadioGroup.vue";
import MultiSwitch from "./input/MultiSwitch.vue";
import MultiSwitchItem from "./input/MultiSwitchItem.vue";
import Switch from "./input/Switch.vue";
import OrderBy from "./tables/OrderBy.vue";
import TabGroup from "./tabs/TabGroup.vue";
import Skeleton from "./tables/Skeleton.vue";
import VerticalSubTabsLayout from "./layouts/VerticalSubTabsLayout.vue";
import NumberInput from "./input/NumberInput.vue";
import LicensePlateInput from "./input/LicensePlateInput.vue";
import FormPage from "./layouts/form_page/FormPage.vue";
import TabContent from "./tabs/TabContent.vue";
import TabContentWrapper from "./tabs/TabContentWrapper.vue";
import Modal from "./modal/Modal.vue";
import ConfirmModal from "./modal/ConfirmModal.vue";
import DialogModal from "./modal/DialogModal.vue";
import Pill from "./pills/Pill.vue";
import FilterPill from "./pills/FilterPill.vue";
import Drawer from "./drawer/Drawer.vue";
import FilterButton from "./buttons/FilterButton.vue";
import DateRangePicker from "./input/DateRangePicker.vue";
import CustomerSelect from "./input/CustomerSelect.vue";
import BackButton from "./buttons/BackButton.vue";
import BreadCrumbs from "./buttons/BreadCrumbs.vue";
import CardListRow from "./card/content/CardListRow.vue";
import CardListItem from "./card/content/CardListItem.vue";
import InformationTooltip from "./tooltips/InformationTooltip.vue";

import PercentageInput from "./input/PercentageInput.vue";
import AmountInput from "./input/AmountInput.vue";
import CustomerPageContainer from "./containers/CustomerPageContainer.vue";
import LoadingIndicator from "./loading/LoadingIndicator.vue";
import ValidationRulesWrapper from "./input/ValidationRulesWrapper.vue";
import ListButton from "./buttons/ListButton.vue";
import HeaderPage from "./layouts/header_page/HeaderPage.vue";
import DashboardHeaderPage from "./layouts/header_page/DashboardHeaderPage.vue";
import DashboardPageHeader from "./layouts/DashboardPageHeader.vue";
import SkeletonHeaderCard from "./skeleton/SkeletonHeaderCard.vue";
import NotificationsManager from "../mixins/notifications/notifications_manager";
import PolissenPage from "./test_pages/PolissenPage.vue";
import ComponentTestPage from "./ComponentTestPage.vue";
import TablePage from "./test_pages/TablePage.vue";
import TestPage from "./test_pages/TestPage.vue";

export default {
  install(Vue) {
    // Register imported components using Vue.component()
    Vue.component("DdInformationTooltip", InformationTooltip);
    Vue.component("DdDashboardOffset", DashboardTabsOffset);
    Vue.component("DdCardListRow", CardListRow);
    Vue.component("DdCardListItem", CardListItem);
    Vue.component("DdBreadCrumbs", BreadCrumbs);
    Vue.component("DdCollapseTransition", CollapseTransition);
    Vue.component("DdBackButton", BackButton);
    Vue.component("DdSkeletonHeaderCard", SkeletonHeaderCard);
    Vue.component("DdListButton", ListButton);
    Vue.component("DdLoadingIndicator", LoadingIndicator);
    Vue.component("DdCustomerSelect", CustomerSelect);
    Vue.component("DdFilterButton", FilterButton);
    Vue.component("DdDrawer", Drawer);
    Vue.component("DdPill", Pill);
    Vue.component("DdFilterPill", FilterPill);
    Vue.component("DdHeaderPage", HeaderPage);
    Vue.component("DdDashboardHeaderPage", DashboardHeaderPage);
    Vue.component("DdCustomerPageContainer", CustomerPageContainer);
    Vue.component("DdModal", Modal);
    Vue.component("DdDialogModal", DialogModal);
    Vue.component("DdConfirmModal", ConfirmModal);
    Vue.component("DdCardStackedList", CardStackedList);
    Vue.component("DdMultiSwitchItem", MultiSwitchItem);
    Vue.component("DdMultiSwitch", MultiSwitch);
    Vue.component("DdSwitch", Switch);
    Vue.component("DdRadio", Radio);
    Vue.component("DdRadioGroup", RadioGroup);
    Vue.component("DdCheckbox", Checkbox);
    Vue.component("DdTaskButton", TaskButton);
    Vue.component("DdButton", Button);
    Vue.component("DdIconButton", IconButton);
    Vue.component("DdDropdownButtonList", DropdownButtonList);
    Vue.component("DdIcon", Icon);
    Vue.component("DdCard", Card);
    Vue.component("DdCollapse", Collapse);
    Vue.component("DdFormGrid", FormGrid);
    Vue.component("DdFormGridItem", FormGridItem);
    Vue.component("DdStep", FormStep);
    Vue.component("DdInputWrapper", InputWrapper);
    Vue.component("DdValidationRulesWrapper", ValidationRulesWrapper);
    Vue.component("DdInput", FormInput);
    Vue.component("DdNumberInput", NumberInput);
    Vue.component("DdTextarea", FormTextarea);
    Vue.component("DdFormIndicator", FormIndicator);
    Vue.component("DdForm", MainForm);
    Vue.component("DdHeaderCard", HeaderCard);
    Vue.component("DdRoundedButton", RoundedButton);
    Vue.component("DdCardLargeText", CardLargeText);
    Vue.component("DdCardList", CardList);
    Vue.component("DdContainer", GeneralContainer);
    Vue.component("DdMasonryGrid", MasonryGrid);
    Vue.component("DdMasonryGridItem", MasonryGridItem);
    Vue.component("DdGrid", GeneralGrid);
    Vue.component("DdGridItem", GeneralGridItem);
    Vue.component("DdMainTable", MainTable);
    Vue.component("DdThinButtonWrapper", ThinButtonWrapper);
    Vue.component("DdCustomerPage", CustomerPage);
    Vue.component("DdPageHeader", PageHeader);
    Vue.component("DdDashboardPageHeader", DashboardPageHeader);
    Vue.component("DdCustomTable", CustomTable);
    Vue.component("DdSubTab", SubTabs);
    Vue.component("DdSubTabGroup", SubTabGroup);
    Vue.component("DdSubTabContentWrapper", SubTabContentWrapper);
    Vue.component("DdSubTabContent", SubTabContent);
    Vue.component("DdTabGroup", TabGroup);
    Vue.component("DdTab", Tab);
    Vue.component("DdTabContent", TabContent);
    Vue.component("DdTabContentWrapper", TabContentWrapper);
    Vue.component("DdTabPane", TabPane);
    Vue.component("DdAvatar", Avatar);
    Vue.component("DdAvatarAndName", AvatarAndName);
    Vue.component("DdSelect", FormSelect);
    Vue.component("DdDatePicker", FormDatePicker);
    Vue.component("DdDateRangePicker", DateRangePicker);
    Vue.component("DdPagination", Pagination);
    Vue.component("DdOrderBy", OrderBy);
    Vue.component("DdSkeleton", Skeleton);
    Vue.component("DdVerticalSubTabsLayout", VerticalSubTabsLayout);
    Vue.component("DdTabContent", TabContent);
    Vue.component("DdTabContentWrapper", TabContentWrapper);
    Vue.component("DdAmountInput", AmountInput);
    Vue.component("DdPercentageInput", PercentageInput);
    Vue.component("DdLicensePlateInput", LicensePlateInput);
    Vue.component("DdFormPage", FormPage);
    // Test Pages
    // Vue.component("PolissenPage", PolissenPage);
    // Vue.component("ComponentTestPage", ComponentTestPage);
    // Vue.component("TablePage", TablePage);
    // Vue.component("TestPage", TestPage);
    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);

    // Register global mixins
    Vue.mixin({
      data() {
        return {
          get notificationsManager() {
            return NotificationsManager;
          },
        };
      },
    });
  },
};
